export const navigateTo = (router, path) => {
   router.push(path);
 };